import React, { useContext, useState, useEffect } from 'react';
import { UserContext } from '../../context/UserContext';
import colaImage from '../../assets/cola.webp';
 

function PurchaseCategoryManager({ onProductSelect, onPriceValue }) {
    const [token] = useContext(UserContext);
    const [categories, setCategories] = useState([]);
    const [currentCategoryId, setCurrentCategoryId] = useState('all');
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [selectedProductId, setSelectedProductId] = useState(null);


    useEffect(() => {
        async function fetchCategories() {
            try {
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + token,
                    },
                };
                const response = await fetch(`/v1/categories`, requestOptions);
                if (!response.ok) throw new Error('Failed to fetch categories');
                const data = await response.json();
                setCategories(data);
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        }
        fetchCategories();
    }, [token]);

    useEffect(() => {
        async function fetchProducts() {
            try {
                const requestOptions = {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + token,
                    },
                };
                const response = await fetch(`/v1/get-venue-products`, requestOptions);
                if (!response.ok) throw new Error('Failed to fetch products');
                const data = await response.json();
                setProducts(data);
            } catch (error) {
                console.error('Error fetching products:', error);
            }
        }
        fetchProducts();
    }, [token]);

    useEffect(() => {
        const filtered = currentCategoryId === 'all' ? products : products.filter(product => product.category_id === currentCategoryId);
        setFilteredProducts(filtered);
    }, [currentCategoryId, products]);

    const handleProductClick = (productId, price) => {
        setSelectedProductId(productId);
        if (onProductSelect) {
            onProductSelect(productId);
        }
        if (onPriceValue) {
            onPriceValue(price);
        }
    };

    return (
        <div className="container mx-auto p-4">
            <div className="flex flex-wrap mb-4">
                <button
                    onClick={() => setCurrentCategoryId('all')}
                    className={`p-2 m-1 ${currentCategoryId === 'all' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
                >
                    All Products
                </button>
                {categories.map((category) => (
                    <button
                        key={category.id}
                        onClick={() => setCurrentCategoryId(category.id)}
                        className={`p-2 m-1 ${currentCategoryId === category.id ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
                    >
                        {category.name}
                    </button>
                ))}
            </div>
            <div className="grid grid-cols-4 gap-2">
                {filteredProducts.map((product) => (
                    <div
                        key={product.id}
                        onClick={() => handleProductClick(product.id, product.price)}
                        className={`p-4 border border-gray-200 rounded-lg ${selectedProductId === product.id ? 'bg-blue-500 text-white' : ''}`}
                    >
                        <img 
                            src={colaImage} 
                            alt="Cola Logo Placeholder" 
                            className="rounded-full mx-auto w-1/2" 
                        />
                        <h3 className="text-lg font-bold">{product.name}</h3>
                        <p>Precio: €{product.price}</p>
                        <p>Stock: {product.stock_quantity}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default PurchaseCategoryManager;
